const AUTH_SERVER_URL = 'https://auth.documedias.com/';

// Production
const AUTH_SERVER_FRONTEND_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcHBsaWNhdGlvbklkIjozMzQ3LCJjb25ncmVzc0lkIjoxNjEzLCJkYXRlIjoiMjAyNi0wMS0yMFQwODowMDo1Ny4xNDFaIiwiaWF0IjoxNzY4ODk2MDU3fQ.DLrUlSDGWYSvoGB_n2JtBcjdgSNZG3eqPSje89rv28o';
const PLANNER_API_URL = 'https://esaic2026.planner.documedias.systems/api';

// Development
// const AUTH_SERVER_FRONTEND_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcHBsaWNhdGlvbklkIjozMzQ4LCJjb25ncmVzc0lkIjoxNjEzLCJkYXRlIjoiMjAyNi0wMS0yMFQwODowMToyMS40MzVaIiwiaWF0IjoxNzY4ODk2MDgxfQ._VUmJeqMwe6a2STVB9lQCpyHM6OP1k_bLfRIbsAbya8';
// const PLANNER_API_URL = 'http://127.0.0.1:8000/api';

const PLANNER_API_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJkYXRlIjoiMjAyMC0wNy0wOVQwNzo0MzoxNS4zMjRaIiwiaWQiOjI3MjYzLCJpYXQiOjE1OTQyODA1OTV9.Br6-wpymBvaIbteoz-rjZuzxnuJB9sTOeP0vUgYkTYk';

const CONGRESS_ID = 1613;
const SUBMISSION_API_URL = 'https://esaic2026.abstract.documedias.systems/api/v1/manager/abstract/multi/html/id/{{ids}}/template/planner_preview';

export {
  PLANNER_API_URL,
  PLANNER_API_KEY,
  AUTH_SERVER_URL,
  AUTH_SERVER_FRONTEND_KEY,
  CONGRESS_ID,
  SUBMISSION_API_URL,
}